import React from 'react';
import { formatDate } from '~/util';
import { createdByUserName, getGapNotePCM } from '~/util/reminderUtils';
import { AddReminder, ReminderStatus } from '~/components/Reminders';

interface ReminderInfoProps {
    reminder: ReminderType;
    patient: PatientType;
    performEdit: (description: string, dueDate: string) => Promise<void>;
    setFormDirty: (value: ((prevState: boolean) => boolean) | boolean) => void;
    setStatusDirty: (value: ((prevState: boolean) => boolean) | boolean) => void;
}

export function ReminderInfo({
    reminder,
    patient,
    performEdit,
    setFormDirty,
    setStatusDirty,
}: ReminderInfoProps) {
    const createdByUser = React.useMemo(() => {
        return createdByUserName(reminder);
    }, [reminder]);

    return (
        <div>
            <div className="row mb-2">
                <div className="col ">
                    <div className="fw-bold">Patient</div>
                    <div>
                        {patient.first_name} {patient.last_name}
                    </div>
                </div>
                <div className="col">
                    <div className="fw-bold">DOB</div>
                    <div>{formatDate(patient.dob)}</div>
                </div>
            </div>
            <div className="row mb-2">
                <div className="col">
                    <div className="fw-bold">Created By</div>
                    <div>{createdByUser || 'System'}</div>
                </div>
                <div className="col">
                    <div className="fw-bold">Measure</div>
                    <div className="reminder-gap-name">
                        {reminder?.timely_action
                            ? reminder.timely_action.metadata.measureShortName
                            : getGapNotePCM(reminder, null) || 'None'}
                    </div>
                </div>
            </div>
            <AddReminder
                performAdd={performEdit}
                existingReminder={reminder}
                setFormDirty={setFormDirty}
                disabled={!!reminder?.timely_action}
            />
            <div className="row mt-3">
                <div className="col text-center">
                    <ReminderStatus reminder={reminder} setStatusDirty={setStatusDirty} />
                </div>
            </div>
        </div>
    );
}
